export const getMediaDevices = async (kind) =>
  (await navigator.mediaDevices.enumerateDevices()).filter(
    (device) => device.kind === kind,
  )
